const base = '/panel'
const routes = {
  api: {
    login: '/login',
    get_dashboard: '/login',
    reset_password: '/reset_password',
    users: '/users',
    getUserAdmin: '/users/get_admin',
    change_user_password: '/users/change_password',

    pages: '/access/pages',
    permissions: '/access/permissions',
    pagination_permissions: '/access/get_permissions',
    get_page_permissions: '/access/permissions/get_page_permissions',

    roles: '/access/roles',
    role_add_permission: '/access/roles/add_permission',
    add_user: '/access/roles/add_user',

    Installer_get_list: '/users/installers',
    Installer_store: '/users/installers',
    Installer_update: '/users/installers/_ID_',
    Installer_delete: '/users/installers/_ID_',
    Get_installer: '/users/get_installer',

    Coworkers_get_list: '/users/coworkers',
    Coworkers_store: '/users/coworkers',
    Coworkers_update: '/users/coworkers/_ID_',
    Coworkers_delete: '/users/coworkers/_ID_',

    Projects_get: '/projects',
    Projects_get_logs: '/projects/_ID_/logs',
    Projects_delete: '/projects/delete_project/_ID_',

    Project_sell_search_contract: '/projects/sell/search_contract',
    Project_sell_get: '/projects/sell/get',
    Project_sell_store: '/projects/sell/store',
    Project_sell_store_export: '/projects/sell/store_export',
    Project_sell_get_export: '/projects/sell/get_export/_ID_',
    Project_sell_update: '/projects/sell/update/_ID_',
    Project_sell_delete: '/projects/sell/destroy/_ID_',
    Project_sell_update_status: '/projects/sell/update_status/_ID_',
    Project_store_files: '/projects/sell/store_file/_ID_',
    Project_store_Assistance: '/projects/sell/add_assistance/_ID_',

    Project_get_detail: '/projects/get_detail/_ID_',
    Project_save_print_file: '/projects/save_print_file',

    Project_production_get: '/projects/production/get',
    Project_production_get_export: '/projects/production/get_exports',
    Project_production_update_status: '/projects/production/update_status/_ID_',
    Project_production_update_status_report: '/projects/production/update_status_with_report/_ID_',

    Project_buy_get: '/projects/buy/get',
    Project_buy_update_status: '/projects/buy/update_status/_ID_',

    Project_management_get: '/projects/management/get',
    Project_management_update_status: '/projects/management/update_status/_ID_',

    Project_accountant_get: '/projects/accountant/get',
    Project_accountant_update_status: '/projects/accountant/update_status/_ID_',
    Project_accountant_update_status_report: '/projects/accountant/update_status_with_report/_ID_',

    Project_installer_get: '/projects/installer/get',
    Project_add_meter: '/projects/installer/add_meter/_ID_',
    Project_add_installer: '/projects/installer/add_installer/_ID_',
    Project_installer_update_status: '/projects/installer/update_status/_ID_',
    Project_installer_store_files: '/projects/installer/store_file/_ID_',

    Upload_file: '/uploads/store_file',

    get_all_users: '/users/get_users',
    get_users_statistic_api: '/users/report',
    get_user_info: '/users/show/_ID_',

    get_profiles: '/profiles',
    store_profiles: '/profiles',
    update_profiles: '/profiles/_ID_',
    delete_profiles: '/profiles/_ID_',

  },
}
const routeGetters = {
  routeApi: state => url => base + state.api[url],
}
export default {
  state: routes,
  getters: routeGetters,
}
